import script from "./textListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./textListPage.vue?vue&type=script&setup=true&lang=js"

import "./textListPage.vue?vue&type=style&index=0&id=0f9ab045&scoped=true&lang=css"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f9ab045"]])

export default __exports__